<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pu_vendname,pr_detail"
      placeholder="输入供应商、物料进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'PurchaseDeliveryTrace', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.pr_detail}}</p>
          <p class="list-item-muted">{{item.pr_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.main_vendname}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{ item.dt_delivery }}</p>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    FilterBar,
    ScrollList,
    SearchBar
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/purchase/delivery/deliverytrace/purc/list",
      params: {
        mode: "MAIN",
        number: 1,
        size: 99999
      },
      filters: [
        {
          type: "date",
          name: "deliverytrace.createTime"
        },
      ]
    };
  }
}
</script>